import { render } from "./rubricApp.vue?vue&type=template&id=f8330e3a&scoped=true"
import script from "./rubricApp.vue?vue&type=script&lang=js"
export * from "./rubricApp.vue?vue&type=script&lang=js"

import "./rubricApp.vue?vue&type=style&index=0&id=f8330e3a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f8330e3a"

export default script